export default __webpack_public_path__ + "static/SOVAMED-2375e9953187dce8328606e4aaf0657e.png";